import React from 'react'
import {Controller} from 'react-hook-form'
import {AiOutlineInfoCircle} from 'react-icons/ai'
import {removeDoubleQuotes} from 'utils/helper'
import {VmoFormField, VmoFormInput, VmoFormTextArea, VmoTooltip} from 'vmo-library'

function Input({
  name,
  control,
  required = false,
  width = 16,
  fieldProps = {},
  label,
  tooltipProps = {},
  defaultValue,
  extraContent,
  extraContentAbove,
  ...rest
}) {
  return (
    <VmoFormField required={required} width={width} {...fieldProps}>
      <div className="info-header">
        <label htmlFor={name}>{label}</label>
        {Object.keys(tooltipProps).length ? <VmoTooltip trigger={<AiOutlineInfoCircle />} {...tooltipProps} /> : null}
      </div>
      {extraContentAbove && <p className="vmo-lead">{extraContentAbove}</p>}
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({field: {value, onChange}, fieldState: {error}}) => (
          <VmoFormInput
            id={name}
            value={value}
            onChange={(e, {value: val}) => onChange(val)}
            error={error && removeDoubleQuotes(error?.message ?? '')}
            {...rest}
          />
        )}
      />
      {extraContent}
    </VmoFormField>
  )
}

function TextArea({
  name,
  control,
  required = false,
  width = 16,
  fieldProps = {},
  label,
  tooltipProps = {},
  extraContent,
  ...rest
}) {
  return (
    <VmoFormField required={required} width={width} {...fieldProps}>
      <div className="info-header">
        <label htmlFor={name}>{label}</label>
        {Object.keys(tooltipProps).length ? <VmoTooltip trigger={<AiOutlineInfoCircle />} {...tooltipProps} /> : null}
      </div>
      <Controller
        control={control}
        name={name}
        render={({field: {value, onChange}, fieldState: {error}}) => (
          <VmoFormTextArea
            id={name}
            value={value}
            onChange={(e, {value: val}) => onChange(val)}
            error={error && {content: removeDoubleQuotes(error?.message ?? '')}}
            {...rest}
          />
        )}
      />
      {extraContent}
    </VmoFormField>
  )
}

export {Input, TextArea}
